/* Strona opinii marki: filtry, "Pokaż więcej", relacje, dodawanie do koszyka i pomiar. */
(function () {
  var root = document.querySelector('.om');
  if (!root) return;
  var dane = JSON.parse(document.getElementById('om-dane').textContent);
  var marka = dane.marka;
  var NA_STRONE = 16;
  var widoczne = NA_STRONE;
  var filtr = 'wszystkie';
  var karty = [].slice.call(root.querySelectorAll('.om-karta'));

  function publikuj(nazwa, parametry) {
    var dane = Object.assign({ marka: marka }, parametry || {});
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(nazwa, dane);
      }
    } catch (e) {}
    // GA4: tag Google z aplikacji Google & YouTube pojawia się na stronie dopiero po zgodzie na cookies
    // (sprawdzone 09.10.2026), więc bez zgody nic nie wysyłamy. Ten sam tag wysyła zakupy, więc to ta sama wizyta.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', nazwa, Object.assign({ send_to: 'G-1QWGS0BE3B' }, dane));
      }
    } catch (e) {}
  }

  /* --- koszyk: atrybut zrodlo_opinie przy pierwszym kliknięciu --- */
  var oznaczono = false;
  function oznaczKoszyk() {
    if (oznaczono) return Promise.resolve();
    oznaczono = true;
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { zrodlo_opinie: marka } })
    }).catch(function () {});
  }
  function zaCzas(promise, ms) {
    return Promise.race([promise, new Promise(function (r) { setTimeout(r, ms); })]);
  }
  function toast(html) {
    var t = document.createElement('div');
    t.className = 'om-toast'; t.innerHTML = html; document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
  function dodaj(btn) {
    var wariant = btn.getAttribute('data-om-dodaj');
    var miejsce = btn.getAttribute('data-miejsce');
    var produkt = btn.getAttribute('data-om-produkt');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(wariant), quantity: 1,
        properties: { _zrodlo: 'opinie-' + marka, _miejsce: miejsce } }] })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return oznaczKoszyk(); })
      .then(function () {
        publikuj('opinie_do_koszyka', { produkt: produkt, miejsce: miejsce });
        toast('Dodano do koszyka <a href="/cart">Przejdź do koszyka</a>');
      })
      .catch(function () { toast('Nie udało się dodać. <a href="/cart">Otwórz koszyk</a>'); })
      .then(function () { btn.disabled = false; });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-om-dodaj]');
    if (btn) { e.preventDefault(); dodaj(btn); return; }
    var link = e.target.closest('a[data-om-produkt]');
    if (link) {
      e.preventDefault();
      publikuj('opinie_klik_produkt', { produkt: link.getAttribute('data-om-produkt'), miejsce: link.getAttribute('data-miejsce') });
      zaCzas(oznaczKoszyk(), 800).then(function () { window.location.href = link.href; });
    }
  });

  /* --- filtry i "Pokaż więcej" --- */
  function pasuje(k) {
    if (filtr === 'wszystkie') return true;
    if (filtr === 'media') return k.hasAttribute('data-media');
    if (filtr === 'slabe') return Number(k.getAttribute('data-ocena')) <= 3;
    if (filtr.indexOf('produkt:') === 0) return k.getAttribute('data-produkt') === filtr.slice(8);
    if (filtr.indexOf('temat:') === 0) return (k.getAttribute('data-tematy') || '').split('|').indexOf(filtr.slice(6)) > -1;
    return true;
  }
  function odswiez() {
    var n = 0;
    karty.forEach(function (k) {
      var ok = pasuje(k);
      if (ok) n++;
      k.hidden = !ok || n > widoczne;
    });
    var wiecej = document.getElementById('om-wiecej');
    wiecej.hidden = n <= widoczne;
  }
  root.querySelectorAll('[data-filtr]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-filtr]').forEach(function (x) { x.classList.remove('om-on'); });
      b.classList.add('om-on'); filtr = b.getAttribute('data-filtr'); widoczne = NA_STRONE; odswiez();
      publikuj('opinie_filtr', { filtr: filtr });
    });
  });
  document.getElementById('om-wiecej').addEventListener('click', function () { widoczne += NA_STRONE; odswiez(); });
  odswiez();

  /* --- relacje --- */
  var okno = document.getElementById('om-relacje');
  var slajd = document.getElementById('om-slajd');
  var paski = document.getElementById('om-paski');
  var lista = dane.relacje.slice();
  if (dane.badanie && dane.badanie.twierdzenia && dane.badanie.twierdzenia.length) lista.push({ typ: 'badanie' });
  var biezaca = 0, start = 0, raf = 0, CZAS = 6000, wstrzymane = false, ostatniFokus = null;
  paski.innerHTML = lista.map(function () { return '<i><b></b></i>'; }).join('');
  var wypelnienia = [].slice.call(paski.querySelectorAll('b'));

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function zgodaMarketing() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed && Shopify.customerPrivacy.marketingAllowed()); }
    catch (e) { return false; }
  }
  function film(id) {
    wstrzymaj();
    var box = document.createElement('div'); box.className = 'om-yt';
    function laduj() {
      box.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&playsinline=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Film z opinią"></iframe>';
      publikuj('opinie_wideo_start', { youtube_id: id });
    }
    if (zgodaMarketing()) { laduj(); }
    else {
      box.innerHTML = '<div class="om-yt-info">Film pochodzi z YouTube, który może zapisać pliki cookie.<br><button type="button">Odtwórz</button></div>';
      box.querySelector('button').addEventListener('click', laduj);
    }
    slajd.appendChild(box);
  }
  function rysuj(r) {
    if (r.typ === 'badanie') {
      return '<div class="om-relacje__tlo" style="background:#141414"></div><div class="om-relacje__stat">' +
        dane.badanie.twierdzenia.map(function (t) {
          var s = String(t).split(' ');
          return /%$/.test(s[0]) ? '<b>' + esc(s[0]) + '</b><p>' + esc(s.slice(1).join(' ')) + '*</p>' : '<p>' + esc(t) + '*</p>';
        }).join('') +
        '<small>' + esc(dane.badanie.przypis) + '</small></div>';
    }
    var cta = r.produktUrl ? '<a class="om-relacje__cta" href="' + esc(r.produktUrl) + '?z=opinie-' + esc(marka) +
      '" data-om-produkt="' + esc(r.produkt) + '" data-miejsce="relacja">Zobacz ' + esc(r.produktTytul) + ' · ' + esc(r.cena) + '</a>' : '';
    return '<div class="om-relacje__tlo" style="background-image:url(\'' + esc(r.obraz) + '&width=900\')"></div>' +
      '<div class="om-relacje__cien"></div><div class="om-relacje__tekst"><q>„' + esc(r.tekst) + '”</q><div>' +
      (r.zweryfikowany ? 'Zweryfikowany zakup · ' : '') + esc(r.autor) + ' · ' + esc(r.data) + '</div></div>' + cta;
  }
  function pokaz(i) {
    if (i < 0) i = 0;
    if (i >= lista.length) { zamknij(); return; }
    biezaca = i;
    slajd.innerHTML = rysuj(lista[i]);
    wypelnienia.forEach(function (f, k) { f.style.width = k < i ? '100%' : '0'; });
    wstrzymane = false; start = performance.now(); cancelAnimationFrame(raf);
    if (lista[i].youtube) film(lista[i].youtube); else krok();
  }
  function krok() {
    if (wstrzymane) return;
    var p = (performance.now() - start) / CZAS;
    wypelnienia[biezaca].style.width = Math.min(100, p * 100) + '%';
    if (p >= 1) { pokaz(biezaca + 1); return; }
    raf = requestAnimationFrame(krok);
  }
  function wstrzymaj() { wstrzymane = true; cancelAnimationFrame(raf); }
  function otworz(i) {
    ostatniFokus = document.activeElement;
    okno.hidden = false; document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('om-relacje-otwarte');
    document.getElementById('om-x').focus();
    publikuj('opinie_relacja_otwarta', { start: i });
    pokaz(i);
  }
  function zamknij() {
    wstrzymaj(); okno.hidden = true; slajd.innerHTML = ''; document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('om-relacje-otwarte');
    if (ostatniFokus) ostatniFokus.focus();
  }
  root.querySelectorAll('[data-relacja]').forEach(function (b) {
    b.addEventListener('click', function () { otworz(Number(b.getAttribute('data-relacja')) || 0); });
  });
  document.getElementById('om-x').addEventListener('click', zamknij);
  document.getElementById('om-lewo').addEventListener('click', function () { pokaz(biezaca - 1); });
  document.getElementById('om-prawo').addEventListener('click', function () { pokaz(biezaca + 1); });
  document.addEventListener('keydown', function (e) {
    if (okno.hidden) return;
    if (e.key === 'Escape') zamknij();
    if (e.key === 'ArrowRight') pokaz(biezaca + 1);
    if (e.key === 'ArrowLeft') pokaz(biezaca - 1);
    if (e.key === 'Tab') {
      var f = [].slice.call(okno.querySelectorAll('button, a[href]'));
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
})();
